import CloseIcon from '@mui/icons-material/Close';
import { DraggableOnCropper } from "./DraggableOnCropper";
import { Tooltip } from '@mui/material';
import { useCropperStore } from '@src/v3.0.0/store/cropper/cropper-store';
import { useFurnituresStore } from '@src/v3.0.0/store/furnitures/store';

import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { StyledFurnitureImage, StyledActionButton, StyledBoundingBox, StyledFurnitureActions, StyledFurniturePosInfo } from './styled';
import { useState } from 'react';

/**
 * FurniturePositionInfo
 * @param {object} inProps {x, y, heightCm, widthCm}
 */
function FurniturePositionInfo(inProps) {
  const {x, y, heightCm, widthCm} = inProps;

  const cropperStore = useCropperStore();
  if (!cropperStore?.element?.cropper) {
    return;
  }

  const cropperWidth = cropperStore.element.cropper.cropBoxData.width;
  const cropperHeight = cropperStore.element.cropper.cropBoxData.height;
  const wallWidth = cropperStore.preset.width;
  const pxPerCentimeter = cropperWidth / wallWidth;
  const posX = cropperWidth / 100 * x;
  const posY = cropperHeight - ( cropperHeight / 100 * y );

  return (
    <StyledFurniturePosInfo>
      Px {posX.toFixed(2)}, {posY.toFixed(2)} <br />
      CmX {(posX / pxPerCentimeter).toFixed(2)}, CmY {(posY / pxPerCentimeter).toFixed(2)} <br />
      LxA {widthCm} x {heightCm} Cm
    </StyledFurniturePosInfo>
  )
}

let furnitureCounter = 0;
export const FurnitureObject = (inProps) => {
  furnitureCounter++;
  
  const { img, Vector, id, uid, x, y, zIndex, ...dimension } = inProps;
  const preset = useCropperStore(s => s.preset);
  const {removeItem, incrementZIndex, decrementZIndex, updateItem} = useFurnituresStore();
  const [localPos, setLocalPos] = useState({ x, y });
  
  function getStyles() {
    const width = `${100 * (dimension.widthCm / preset.width)}%`;
    const height = `${100* (dimension.heightCm / preset.height)}%`;
    return ({
      width,
      height,
      zIndex
    });
  }

  return (
    <DraggableOnCropper
      handle={uid}
      x={x}
      y={y}
      onDrag={({ x, y }) => {
        setLocalPos({ x, y });
      }}
      onStop={(e, { x, y }) => {
        updateItem(uid, x, y);
      }}
      disable={[
        `${uid}-actions`
      ]}
    >
      <StyledBoundingBox id={uid} data-furniture-uid={uid} sx={getStyles()}>
        <StyledFurnitureActions id={`${uid}-actions`}  direction={'row'} gap={0.5}>
          <Tooltip title="Rimuovi">
            <StyledActionButton onClick={() => removeItem(uid)}><CloseIcon /></StyledActionButton>
          </Tooltip>
          <Tooltip title="Livello sopra">
            <StyledActionButton onClick={() => incrementZIndex(uid)}><ArrowUpwardIcon /></StyledActionButton>
          </Tooltip>
          <Tooltip title="Livello sotto">
            <StyledActionButton onClick={() => decrementZIndex(uid)}><ArrowDownwardIcon /></StyledActionButton>
          </Tooltip>
          <FurniturePositionInfo {...localPos} {...dimension} />
        </StyledFurnitureActions>
        <div className='furniture-img-container'>
          {img && <StyledFurnitureImage bg={img} />}
          {Vector && <Vector style={{ width: '100%', height: '100%', position: 'absolute', top: 0, left: 0 }} />}
        </div>
      </StyledBoundingBox>
    </DraggableOnCropper>
  );
};